module.exports = __webpack_public_path__ + "static/vote-for-policies-dfeda5177a486d2e59c47c3dd874aede.svg";